import getLinkConfig from './get-link-config';

export default {
  getLinkConfig,
};
